import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserData } from 'src/app/models/userData.model';
import { LoginService } from 'src/app/services/login.service';
import { filter, debounceTime } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common.service';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { Px2RemService } from 'src/app/services/px2-rem.service';
import { MobileEcatalogService } from "./mobile/mobile-ecatalog.service"
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.less']
})
export class ProductComponent implements OnInit {
  productList: any[] = [];
  isSpinning: boolean = false;
  stickyTop: boolean = false;
  isScrollBottom: boolean = false;

  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  vehicle: any = undefined;
  type: string | undefined;
  title: string | undefined;
  userData: UserData | undefined;
  isLogin: boolean = false;
  category: string[] | undefined;
  categoryGa: string | undefined;
  categoryName: string[] | undefined;
  tempQuantity: number | undefined;
  //  about mobile
  searchTabsIndex: number = 0;
  vinSearchValue: string = '';
  vehicleSearchValue: string = '';
  companySearchValue: string = '';
  isDealerPortal: boolean = false;

  vinResultListVisible: boolean = false;
  isMobile() {
    const userAgent = navigator.userAgent;
    const mobileKeywords = [
      'Android',
      'iPhone',
      'iPad',
      'Windows Phone',
      'BlackBerry',
      'Opera Mini',
      'Symbian',
      'Kindle',
      'Mobile'
    ];

    const regex = new RegExp(mobileKeywords.join('|'), 'i');
    const screenWidth = window.innerWidth;
    const mobileThreshold = 768; // 根据实际情况调整阈值

    return screenWidth < mobileThreshold && regex.test(userAgent);;
  }

  constructor(
    private loginService: LoginService,
    private px2RemService: Px2RemService,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private message: NzMessageService,
    public router: Router,
    private cartService: CartService,
    private ecatalogService: EcatalogService,
    private mobileProductService: MobileEcatalogService,
    private translate:TranslateService,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
    // 监听路由变化事件
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(event.url.includes('/ecatalog')){
          const storedMobileProductParams= localStorage.getItem('mobileProductParams');
          const param = storedMobileProductParams ? JSON.parse(storedMobileProductParams) : null
          this.vinResultListVisible = false;
          if(param){
            this.vinSearchValue = param?.vin || '';
            this.companySearchValue = param?.product || '';
            this.vehicleSearchValue = param?.vehicleText || '';
            this.searchTabsIndex = param?.tabIndex || 0;
            this.type = param?.type;
            this.vehicle = param?.vehicle;
            this.productList = [];
            if(this.type === 'product'){
              this.category = []
            }
            this.getList();
          }else{
            this.productList = [];
            this.getList();
          }
        }
      }
    });
    this.route.queryParams.subscribe((params) => {
      if (params?.['searchText']) {
        this.getList(params?.['searchText']);
      }
    });


    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }

  ngOnInit(): void {
    const _this = this;
    window.addEventListener('scroll', function() {
      var scrollTop = document.documentElement.scrollTop;
      var clientHeight = document.documentElement.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight;

      debounceTime(200)
      if(scrollTop > 230){
        _this.stickyTop = true;
      }else{
        _this.stickyTop = false;
      }
      // 到底部了
      if(clientHeight + scrollTop >= scrollHeight - 200 ){
        _this.isScrollBottom = true
      }else{
        _this.isScrollBottom = false
      }
    });

    this.loginService.userData$.subscribe((userData: any) => {
      this.userData = userData;
      this.isLogin = userData?.token ? true : false;
    });


  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }
  vehicleSelected(data: any): void {
    this.vehicle = data.vehicle;
    this.type = data.type;
    this.getList();
  }
  categorySelected({ selectedKeys, nodeKey }: { selectedKeys: string[]; nodeKey: string }): void {
    this.pagination.pageIndex = 1;
    this.category = selectedKeys;
    this.categoryGa = nodeKey;
    this.getList()
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  deleteFilter() {
    this.type = undefined;
    this.title = undefined;
    this.getList();
  }


  getList(title?: string) {
    let dynamicObject = {};
    if (title) {
      dynamicObject = {
        "query": title
      }
      this.title = title;
    } else {
      switch (this.type) {
        case 'vehicle':
          dynamicObject = {
            "linkageTargetId": this.vehicle?.linkageTargetId || undefined,
            "linkageTargetType": this.vehicle?.linkageTargetType || undefined,
            "manuId": this.vehicle?.manuId,
            "modelClass": this.vehicle?.modelClass,
            "manufacturer": this.vehicle?.manufacturer,
            "modelId": this.vehicle?.modelId,
            "year": this.vehicle?.year?.join(','),
            "displacement": this.vehicle?.displacement?.join(','),
          }
          this.title = this.vehicle?.vehicleModelSeriesName;
          break;
        case 'product':
          dynamicObject = {
            "query": this.vehicle
          }
          this.title = this.vehicle;
          break;
        case 'vin':
          if (Array.isArray(this.vehicle)) {
            // Handle the case where `this.vehicle` is an array
            dynamicObject = {
              "linkageTargetId": this.vehicle[0]?.carId || undefined,
              "linkageTargetType": this.vehicle[0]?.linkageTargetType || undefined,
              "levelIds": this.vehicle[0]?.levelIds || undefined,
              "cardIds":this.vehicle?.filter(item => item?.checked !== false)?.map(item => item?.carId),
            };
            this.title = this.vehicle.map(item => item?.carName).filter(id => id !== undefined)?.join(',');
          } else {
            // Handle the case where `this.vehicle` is an object
            dynamicObject = {
              "linkageTargetId": this.vehicle?.carId || undefined,
              "linkageTargetType": this.vehicle?.linkageTargetType || undefined,
              "levelIds": this.vehicle?.levelIds || undefined,
            };
            this.title = this.vehicle?.carName;
          }
          break;
        case 'rego':
          dynamicObject = {
            "linkageTargetId": this.vehicle?.carId || undefined,
            "linkageTargetType": this.vehicle?.linkageTargetType || undefined,
          }
          break;
        default:
          dynamicObject = {
            "query": ""
          }
          this.title = undefined;
      }
    }
    this.isSpinning = true;
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      categoryNames: this.category
    };
    this.ecatalogService.queryArticleByLinkTarget(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { total, articles } = rtnData
        const productList = articles.map((product: any) => {
          return {
            ...product,
            quantity: 1 ,
            isHoveredCart: false,
            isHoveredMin: false,
            isHoveredAdd: false
          };
        });
        if(!this.isMobile()){
          this.productList = productList
        }else{
          this.productList = [...(this.productList || []), ...productList]
        }
        localStorage.removeItem('mobileProductParams')
        this.pagination.total = total;
        this.isSpinning = false;
      }
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      const { manufacturer, modelClass, year, displacement } = params as any;
      const fullName = [manufacturer, modelClass, year, displacement]
        .filter(val => val !== undefined && val !== null && val !== "")
        .join(" ");
      (window as any).dataLayer.push({
        event: 'dp_ecat_cat_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: fullName,
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.categoryGa,
      });
    }
  }

  goDetail(item: any): void {
    const country = localStorage.getItem("country");
    const url = country?`${country}/product/detail`:'/product/detail';
    this.router.navigate([url], { queryParams: { articleNumber: item.articleNumber, partId: item.partId } });
  }

  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }

  minusQuantity(item: any, event: any): void {
    event.stopPropagation();
    const moq = 1;
    const newQuantity = item.quantity - moq;
    if (moq && newQuantity >= moq) {
      item.quantity = newQuantity;
    }
  }
  onBlur(event:any,item:any): void{
    this.stopPropagation(event);
    if (this.tempQuantity === null || this.tempQuantity === undefined) {
      return;
    }
    const moq = 1;
    item.quantity = this.tempQuantity;

    if (item.quantity === 0 || item.quantity < moq) {

      item.quantity = moq;
    } else if (item.quantity % moq !== 0) {

      item.quantity = Math.ceil(item.quantity / moq) * moq;
    }
  }
  onInputChange(event:any) {
    if (event === undefined || event === null) {
      return;
    }
    this.tempQuantity = Number(event);
  }
  addQuantity(item: any, event: any): void {
    event.stopPropagation();
    const moq = 1;
    if (moq && item.quantity) {
      item.quantity = item.quantity + moq;
    }
  }
  quantityChange(item: any, event: any) {
    event.stopPropagation();
  }
  search(searchText: string, event: any): void {
    event.stopPropagation();
    this.getList(searchText);
  }
  stopPropagation(event: any) {
    event.stopPropagation();
  }
  async addToCart(product: any, event: any): Promise<void> {
    event.stopPropagation();
    let params = {
      expectedDate: this.commonService.formatDateString(new Date()),
      quantity: product.quantity,
      inputMaterialNumber: product.articleNumber
    }
    await this.cartService.addToCart([params]).then(() => {
      this.message.create('success', this.translate.instant('ADD_TO_CART_SUCCESSFULLY'));
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_add_to_cart_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'ecat',
        event_name: 'add to cart',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: '',
      });
    }
  }

  async addProductListToCart(productList: any[]): Promise<void> {
    await this.cartService.addToCart(productList).then(() => {
      this.message.create('success', this.translate.instant('ADD_TO_CART_SUCCESSFULLY'));
    });
  }
}
